import { createAction, props } from "@ngrx/store";
import { Area } from "../../models/area";
import { Division } from "../../models/division";
import { Position } from "../../models/position";
import { BenefitType } from "../../models/benefit-type";
import { Benefit } from "../../models/benefit";
import { SignatureType } from "../../models/signature-type";
import { User } from "../../models/user";
import { SignatureGroup } from "../../models/signature-group";
import { BenefitGroup } from "../../models/benefit-group";
import { HolidayGroup } from "../../models/holiday-group";
import { WithholdingType } from "../../models/withholding-type";
import { CostsPerEmployeeType } from "../../models/cost-per-employee-type";
import { CostsPerEmployee } from "../../models/cost-per-employee";
import { Withholding } from "../../models/withholding";
import { Variable } from "../../models/formulas/variable";
import { ObjectF } from "../../models/formulas/object";
import { WithholdingGroup } from "../../models/withholding-group";
import { FormulaGroup } from "../../models/formulas/formula-group";
import { CostsPerEmployeeGroup } from "../../models/cost-per-employee-group";

export const findDivisionsCatalogAct = createAction('findDivisionsCatalogEffect');
export const loadDivisionsCatalogAct = createAction('loadDivisionsCatalogEffect', props<{ divisions: Division[] }>());

export const findAreasCatalogAct = createAction('findAreasCatalogEffect');
export const loadAreasCatalogAct = createAction('loadAreasCatalogEffect', props<{ areas: Area[] }>());

export const findBenefitTypeCatalogAct = createAction('findBenefitTypeCatalogEffect');
export const loadBenefitTypeCatalogAct = createAction('loadBenefitTypeCatalogEffect', props<{ benefitTypes: BenefitType[] }>());

export const findBenefitsCatalogAct = createAction('findBenefitsCatalogEffect');
export const loadBenefitsCatalogAct = createAction('loadBenefitsCatalogEffect', props<{ benefits: Benefit[] }>());


export const findSignatureTypeCatalogAct = createAction('findSignatureTypeCatalogEffect');
export const loadSignatureTypeCatalogAct = createAction('loadSignatureTypeCatalogEffect', props<{ signatureTypes: SignatureType[] }>());


export const findUsersWithRolAutCatalogAct = createAction('findUsersWithRolAutCatalogEffect');
export const loadUsersWithRolAutCatalogAct = createAction('loadUsersWithRolAutCatalogEffect', props<{ usersWithRolAut: User[] }>());

export const findSignatureGroupsCatalogAct = createAction('findSignatureGroupsCatalogEffect');
export const loadSignatureGroupsCatalogAct = createAction('loadSignatureGroupsCatalogEffect', props<{ signatureGroups: SignatureGroup[] }>());

export const findBenefitGroupsCatalogAct = createAction('findBenefitGroupsCatalogEffect');
export const loadBenefitGroupsCatalogAct = createAction('loadBenefitGroupsCatalogEffect', props<{ benefitGroups: BenefitGroup[] }>());

export const findHolidayGroupsCatalogAct = createAction('findHolidayGroupsCatalogEffect');
export const loadHolidayGroupsCatalogAct = createAction('loadHolidayGroupsCatalogEffect', props<{ holidayGroups: HolidayGroup[] }>());

export const findWithholdingsCatalogAct = createAction('findWithholdingsCatalogEffect');
export const loadWithholdingsCatalogAct = createAction('loadWithholdingsCatalogEffect', props<{ withholdings: Withholding[] }>());

export const findWithholdingTypeCatalogAct = createAction('findWithholdingTypeCatalogEffect');
export const loadWithholdingTypeCatalogAct = createAction('loadWithholdingTypeCatalogEffect', props<{ withholdingTypes: WithholdingType[] }>());

export const findCostsPerEmployeesCatalogAct = createAction('findCostsPerEmployeesCatalogEffect');
export const loadCostsPerEmployeesCatalogAct = createAction('loadCostsPerEmployeesCatalogEffect', props<{ costsPerEmployees: CostsPerEmployee[] }>());

export const findCostsPerEmployeeTypeCatalogAct = createAction('findCostsPerEmployeeTypeCatalogEffect');
export const loadCostsPerEmployeeTypeCatalogAct = createAction('loadCostsPerEmployeeTypeCatalogEffect', props<{ costsPerEmployeeTypes: CostsPerEmployeeType[] }>());

export const findVariablesCatalogAct = createAction('findVariablesCatalogEffect');
export const loadVariablesCatalogAct = createAction('loadVariablesCatalogEffect', props<{ variables: Variable[] }>());

export const findObjectsCatalogAct = createAction('findObjectsCatalogEffect');
export const loadObjectsCatalogAct = createAction('loadObjectsCatalogEffect', props<{ objects: ObjectF[] }>());

export const findWithholdingGroupsCatalogAct = createAction('findWithholdingGroupsCatalogEffect');
export const loadWithholdingGroupsCatalogAct = createAction('loadWithholdingGroupsCatalogEffect', props<{ withholdingGroups: WithholdingGroup[] }>());

export const findFormulaGroupsCatalogAct = createAction('findFormulaGroupsCatalogEffect');
export const loadFormulaGroupsCatalogAct = createAction('loadFormulaGroupsCatalogEffect', props<{ formulaGroups: FormulaGroup[] }>());

export const findCostsPerEmployeeGroupsCatalogAct = createAction('findHCostsPerEmployeeGroupsCatalogEffect');
export const loadCostsPerEmployeeGroupsCatalogAct = createAction('loadCostsPerEmployeeGroupsCatalogEffect', props<{ costsPerEmployeeGroups: CostsPerEmployeeGroup[] }>());
